<template>
    <div>
        <Modal v-model="modal" :title="modelTitle" width="700px" :closable="false" :mask-closable="false">
            <div>
                <!-- {{ awardItem }} -->
                <Form ref="awardItemFormValidate" :model="awardItem" :rules="awardItemRuleValidate" :label-width="80">
                    <FormItem label="获奖时间" prop="awardTime">
                        <DatePicker type="date" v-model="awardItem.awardTime" placeholder="请选择获奖时间" style="width: 100%"></DatePicker>
                    </FormItem>
                    <FormItem label="奖项名称" prop="awardName">
                        <Input v-model.trim="awardItem.awardName" placeholder="请输入奖项名称"></Input>
                    </FormItem>
                    <FormItem label="获奖项目" prop="awardProject">
                        <Input v-model.trim="awardItem.awardProject" placeholder="请输入获奖项目"></Input>
                    </FormItem>
                    <FormItem label="颁奖机构" prop="awardOrgan">
                        <Input v-model.trim="awardItem.awardOrgan" placeholder="请输入颁奖机构"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type="primary" @click="handleConfirm">确认</Button>
                <Button type="primary" @click="handleCancel">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: {
        awardItem: {
            type: Object,
            default: {},
        },
        modelTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            modal: false,
            awardItemRuleValidate: {
                awardName: [
                    {
                        required: true,
                        message: "奖项名称不可为空",
                        trigger: "blur",
                    },
                ],
                awardProject: [
                    {
                        required: true,
                        message: "获奖项目不可为空",
                        trigger: "blur",
                    },
                ],
                awardOrgan: [
                    {
                        required: true,
                        message: "颁奖机构不可为空",
                        trigger: "blur",
                    },
                ],
                awardTime: [
                    {
                        type: "date",
                        required: true,
                        message: "颁奖时间不可为空",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    watch: {
        modal(val, oldVal) {
            if (this.modelTitle == "修改获奖经历") {
                return;
            }
            if (val) {
                this.$refs["awardItemFormValidate"].resetFields();
                this.awardItem.uniquId = "";
            }
        },
    },
    methods: {
        handleCancel() {
            this.modal = false;
        },

        handleConfirm() {
            this.$refs["awardItemFormValidate"].validate((valid) => {
                if (valid) {
                    console.log("this.awardItem", this.awardItem);
                    this.awardItem.awardTime = moment(
                        this.awardItem.awardTime
                    ).format("YYYY-MM-DD");
                    // return
                    this.$emit("getAwardItem", this.awardItem);
                    this.modal = false;
                }
            });
        },
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/wumeigeren/components/ModalAward.vue